/* eslint-disable */

export enum FavoriteType {
  RESERVED_0 = 0,
  TEAMS = 1,
  YAMMER = 2,
  RESERVED_3 = 3,
  RESERVED_4 = 4,
  UNRECOGNIZED = -1,
}

export enum RecentObjectType {
  RES_0 = 0,
  APP = 1,
  CALENDAR = 2,
  SEARCH_QUERY = 3,
  RES_4 = 4,
  RES_5 = 5,
  JOURNEY = 6,
  ADMIN_DASHBOARD_ITEM = 7,
  UNRECOGNIZED = -1,
}

export interface Favorite {
  teamId: string;
  channelId: string;
  upn: string;
  type: FavoriteType;
}

export interface FavoriteResponse {
  item: Favorite | undefined;
}

export interface FavoriteList {
  items: Favorite[];
  count: number;
}

export interface FindFavoriteRequest {
  upn: string;
  teamId?: string | undefined;
  channelId?: string | undefined;
}

export interface RecentObject {
  objectId: string;
  upn: string;
  score: number;
  date?: string | undefined;
  type: RecentObjectType;
  private: boolean;
  limit: number;
}

export interface RecentObjectList {
  items: RecentObject[];
  count: number;
}

export interface RecentObjectResponse {
  item: RecentObject | undefined;
}

export interface FindRecentObjectRequest {
  upn: string;
  type: RecentObjectType;
  id?: string | undefined;
  private?: boolean | undefined;
}
